import { useQueryResponse } from '../core/QueryResponseProvider'
import { ImportacaoErro } from '../core/_models'
import { importacoesErrosColumns } from './columns/_columns'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { IconPaths } from '../../../../../../_metronic/helpers'

export const ImportacaoErroListTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()

  return (
    <CustomTable<ImportacaoErro>
      id='kt_table_importacoes_erro'
      ariaLabel='Erros da importação'
      itemLabel={{ singular: 'erro', plural: 'erros' }}
      data={response?.data || []}
      columns={importacoesErrosColumns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={
        <TableEmptyState
          icon={IconPaths.Check}
          title='Nenhum erro nesta importação'
          description='Todas as linhas válidas da planilha foram processadas.'
        />
      }
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
